import { keyframes } from '@emotion/react'
import { Typography } from '@mui/material'
import { Box } from '@mui/system'
import { useEffect, useRef, useState } from 'react'

export const MarqueeText = (props: { text: string }) => {
	const [shouldPlay, setShouldPlay] = useState(false)
	const [isHover, setIsHover] = useState(false)
	const [isPlay, setIsPlay] = useState(false)
	const childRef = useRef(null)

	useEffect(() => {
		if (shouldPlay && isHover) {
			setIsPlay(true)
		} else {
			setIsPlay(false)
		}
	}, [shouldPlay, isHover])

	useEffect(() => {
		const elem: any = childRef.current
		const childWidth = elem?.offsetWidth
		if (childWidth > 250) {
			setShouldPlay(true)
		} else {
			setShouldPlay(false)
		}
	}, [])

	const marquee = keyframes`
      0% { transform: translate(0%) },
      80% { transform: translate(calc(-100% + 245px)) },
      100% { transform: translate(calc(-100% + 245px)) }
    `

	return (
		<>
			<Box sx={{ position: 'absolute', top: 0, left: 0, zIndex: -1 }}>
				<Box ref={childRef} sx={{ opacity: 0 }}>
					{props.text}
				</Box>
			</Box>

			<Box
				sx={{ width: '200px', color: 'grey', overflowX: 'hidden', whiteSpace: 'nowrap' }}
				onMouseOver={() => {
					setIsHover(true)
				}}
				onMouseLeave={() => {
					setIsHover(false)
				}}
			>
				{isPlay ? (
					<Box
						sx={{
							display: 'inline-block',
							animationName: `${marquee}`,
							animationDuration: '4s',
							animationTimingFunction: 'linear',
							animationIterationCount: 'infinite',
						}}
					>
						{props.text}
					</Box>
				) : (
					<Box
						sx={{
							textAlign: 'right',
							overflow: 'hidden',
							whiteSpace: 'nowrap',
							textOverflow: 'ellipsis',
						}}
					>
						<Typography variant="body3">{props.text}</Typography>
					</Box>
				)}
			</Box>
		</>
	)
}
